"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EventHandler2 = _interopRequireDefault(require("../event/EventHandler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * This class is used for observer changes to the size of the window and send it to the iframe.
 */
var ApplicationResizeObserver = /*#__PURE__*/function (_EventHandler) {
  _inherits(ApplicationResizeObserver, _EventHandler);

  var _super = _createSuper(ApplicationResizeObserver);

  /**
   * Clas constructor.
   *
   * @param {Element} [context] Context to watch.
   */
  function ApplicationResizeObserver() {
    var _this;

    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, ApplicationResizeObserver);

    _this = _super.call(this, {
      supportedEvents: ['resize'],
      componentName: 'ApplicationResizeObserver'
    });
    _this.context = context || document.body;
    _this._images = _this.context.getElementsByTagName('img');
    _this._observer = null;
    _this._size = {
      height: 0,
      width: 0
    };
    _this._updateTimeout = null;

    _this._updateListener = function (event) {
      clearTimeout(_this._updateTimeout);
      _this._updateTimeout = setTimeout(_this.update.bind(_assertThisInitialized(_this)));

      if (event && event.target && event.target && event.target.tagName === 'IMG') {
        event.target.removeEventListener('load', _this._updateListener);
      }
    };

    return _this;
  }
  /**
   * Handles an update.
   */


  _createClass(ApplicationResizeObserver, [{
    key: "update",
    value: function update() {
      var newHeight = this.context.scrollHeight;
      var newWidth = this.context.scrollWidth;

      if (this._size.height !== newHeight && this._size.width !== newWidth) {
        this._size.height = newHeight;
        this._size.width = newWidth;
        this.trigger('resize', Object.assign({}, this._size));

        for (var _i = 0, _Array$from = Array.from(this._images); _i < _Array$from.length; _i++) {
          var image = _Array$from[_i];

          if (!image.complete) {
            image.addEventListener('load', this._updateListener);
          }
        }
      }
    }
    /**
     * Connects observer and adds a listener for resize.
     */

  }, {
    key: "connect",
    value: function connect() {
      if (this._observer === null) {
        this._observer = new MutationObserver(this._updateListener);

        this._observer.observe(this.context, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });

        window.addEventListener('resize', this._updateListener);
        this.update();
      }
    }
    /**
     * Disconnects observer and removes listener for resize.
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      if (this._observer !== null) {
        clearTimeout(this._updateTimeout);

        this._observer.disconnect();

        this._observer = null;
        window.removeEventListener('resize', this._updateListener);
      }
    }
  }]);

  return ApplicationResizeObserver;
}(_EventHandler2.default);

exports.default = ApplicationResizeObserver;